import instanceAxios from "../config/config";
import { AxiosResponse } from "axios";

interface LeaderboardListParams {
    page?: number;
    limit?: number;
    search?: string;
}

interface user {
    _id: string;
    full_name: string;
    email_address: string;
}

interface deck {
    _id: string;
    title: string;
}

interface Leaderboard {
    _id: string;
    user_id: string;
    room_id: string;
    total_score: string;
    deck_id: string;
    quiz_id: string;
    createdAt: string;
    user: user[];
    deck: deck[];
}

interface LeaderboardListResponse {
    data: Leaderboard[];
    count: number;
}

const BASE_URL = `/leaderboard`;

const LeaderboardService = {
    getLeaderboard: (params?: LeaderboardListParams): Promise<AxiosResponse<LeaderboardListResponse>> => {
        return instanceAxios.get(`${BASE_URL}/getAllLeaderboard`, {
            params: {
                page: params?.page ?? 1,
                limit: params?.limit ?? 10,
                searchQuery: params?.search ?? '',
            },
        });
    },
};

export default LeaderboardService;